// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__Fo_-r","subTitleBold":"BoxSubTitle_subTitleBold__XB6y5"};